import { Routes, Route } from 'react-router-dom';
import { SessionStatsProvider } from './contexts/SessionStatsContext';
import AdminLayout from './screens/AdminLayout';
import DashboardHome from './screens/DashboardHome';
import SubjectQuestions from './screens/SubjectQuestions';
import QuestionDetail from './screens/QuestionDetail';

function App() {
  return (
    <div id='MainApp'>
      <SessionStatsProvider>
        <Routes>
          <Route path='/' element={<AdminLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path='subject/:subjectId' element={<SubjectQuestions />} />
            <Route
              path='subject/:subjectId/question/:questionId'
              element={<QuestionDetail />}
            />
          </Route>
        </Routes>
      </SessionStatsProvider>
    </div>
  );
}

export default App;
